import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../providers/AuthProvider';
import {CreditStatusProvider} from "../providers/CreditStatusProvider";

const ProtectedRoutes = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null; // Or a loading spinner component
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <CreditStatusProvider><Outlet /></CreditStatusProvider>;
};

export default ProtectedRoutes;
